import React, { useEffect, useState } from 'react';
import { useFormik } from "formik";
import DynamicForm from "../../../Extracomponents/FormicForm";
import { useLocation, useNavigate } from "react-router-dom";
import { UpdateStockRatingByadmin, GetService } from "../../../Services/Admin/Admin";
import Content from '../../../components/Contents/Content';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';

const UpdateRating = () => {


    const navigate = useNavigate();
    const location = useLocation();
    const { row } = location.state;



    const [servicedata, setServicedata] = useState([]);

    const user_id = localStorage.getItem("id");
    const token = localStorage.getItem("token");


    const validate = (values) => {
        let errors = {};

        if (!values.symbol) {
            errors.symbol = "Please Enter  symbol";
        }

        if (!values.valuation || values.valuation >= 100) {
            errors.valuation = "Please Select valuation Less than 100";
        }
        if (!values.trust || values.trust >= 100) {
            errors.trust = "Please Select Less than 100";
        }
        if (!values.technicals || values.technicals >= 100) {
            errors.technicals = "Please Select Technicals Less than 100";
        }
        if (!values.financial || values.financial >= 100) {
            errors.financial = "Please Select Financial Less than 100";
        }
        if (!values.overall || values.overall >= 100) {
            errors.overall = "Please Select Overall Less than 100";
        }

        return errors;
    };

    const onSubmit = async (values) => {
        const req = {
            id: row._id,
            symbol: values.symbol,
            valuation: values.valuation,
            trust: values.trust,
            technicals: values.technicals,
            financial: values.financial,
            overall: values.overall,

        };

        try {
            const response = await UpdateStockRatingByadmin(req, token);
            if (response.status) {
                showCustomAlert("Success", response.message, navigate, "/admin/stockrating")
            } else {
                showCustomAlert("error", response.message)

            }
        } catch (error) {
            showCustomAlert("error", "An unexpected error occurred. Please try again later.")
        }
    };

    const formik = useFormik({
        initialValues: {
            id: "",
            symbol: row?.symbol || "",
            valuation: row?.valuation || "",
            trust: row.trust || "",
            technicals: row.technicals || "",
            financial: row.financial || "",
            overall: row.overall || "",
        },
        validate,
        onSubmit,
    });


    const fields = [

        {
            name: 'symbol',
            label: 'Symbol',
            type: 'text',
            label_size: 6,
            col_size: 6,
            star: true,
            disable: true
        },

        {
            name: "valuation",
            label: "Valuation",
            type: "number",
            label_size: 12,
            col_size: 6,
            disable: false,
            star: true
        },
        {
            name: "trust",
            label: "Trust",
            type: "number",
            label_size: 12,
            col_size: 6,
            disable: false,
            star: true,

        },
        {
            name: "technicals",
            label: "Technicals",
            type: "number",
            label_size: 12,
            col_size: 6,
            disable: false,
            star: true,

        },
        {
            name: "financial",
            label: "Financial",
            type: "number",
            label_size: 12,
            col_size: 6,
            disable: false,
            star: true
        },
        {
            name: "overall",
            label: "Over All",
            type: "number",
            label_size: 12,
            col_size: 6,
            disable: false,
            star: true,

        },


    ];


    return (
        <Content
            Page_title="Update Stock Rating"
            button_status={false}
            backbutton_status={true}
            backForword={true}
        >
            <DynamicForm
                fields={fields.filter((field) => !field.showWhen || field.showWhen(formik.values))}
                page_title="Update Stock Rating"
                btn_name="Update Stock Rating"
                btn_name1="Cancel"
                formik={formik}
                sumit_btn={true}
                btn_name1_route={"/admin/stockrating"}
                additional_field={<></>}
            />
        </Content>
    );
};

export default UpdateRating;
